import { chatbotActionButton } from '../../components/action-buttons/action-buttons.consts';
import { PartNumbersActionButton, PartNumbersActionName } from './partnumber-list.types';

/** User-settings key the column configuration is saved under. */
export const PART_NUMBERS_COLUMN_LIST = 'column_list-partnumber';

/** Form key the plant's allowed fields are read under. */
export const PART_NUMBERS_FIELDS_KEY = 'PARTNUMBERS_MODULE_FORMKEY';

/** Namespace the column captions are translated from, by field name. */
export const PART_NUMBERS_COLUMN_LABEL_PREFIX = 'defaultFields.partnumbers-module.';

/** Kept so a second click reuses the dialog rather than opening another. */
export const PART_NUMBERS_COLUMNS_DIALOG_ID = 'partnumbers-select-columns-dialog';

export const PART_NUMBERS_TEST_IDS = {
  columnSelect: 'partnumbers-column-select',
} as const;

export const partNumbersActionButtons: PartNumbersActionButton[] = [
  chatbotActionButton(PartNumbersActionName.CHATBOT),
];
